<template>
	<label @keydown.enter="labelToggle" @keydown.space="labelToggle" :for="labelFor" class="form-toggle" tabindex="0">
		<input
			ref="input"
			:checked="checked"
			@input="$emit('input', { campaigns: [name], status: $event.target.checked ? 'active' : 'paused' })"
			type="checkbox"
			:id="id"
		/>
		<span class="toggle-switch" />
	</label>
</template>

<script>
export default {
	props: {
		checked: Boolean,
		name: {
			type: String,
			required: true,
		},
		id: {
			type: String,
			default: '',
		},
	},
	computed: {
		labelFor () {
			return this.id;
		},
	},
	methods: {
		labelToggle() {
			this.$refs.input.click();
		},
	},
};
</script>

<style lang="scss">
// Switch Toggle
/* The toggle - the box around the toggle-switch */
.form-toggle {
	position: relative;
	display: inline-block;
	width: 21px;
	height: 14px;

	input {
		display: none;

		&:checked {
			& + .toggle-switch {
				background-color: #74ba0d;

				&:before {
					transform: translateX(7px);
				}
			}
		}

		&:focus {
			& + .toggle-switch {
				box-shadow: 0 0 1px #74ba0d;
			}
		}
	}

	.toggle-switch {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #ce1f32;
		border-radius: 15px;
		transition: 0.2s;

		&:before {
			position: absolute;
			content: '';
			height: 12px;
			width: 12px;
			left: 1px;
			bottom: 1px;
			background-color: white;
			border-radius: 50%;
			transition: 0.2s;
		}
	}
}
</style>
